module.exports = __webpack_public_path__ + "img/analogue-webfont.ebc0e1a.svg";